'use client'

import clsx from 'clsx'
import React from 'react'
import { ExternalToast, toast as sonnerToast, Toaster as Sonner } from 'sonner'

import { cn } from '../../lib'
import { HStack } from '../layout'
import { Typography } from '../typography'

export const Toaster = ({
  position = 'bottom-center',
  offset = { bottom: '8px' },
  mobileOffset = { bottom: '8px' },
  ...props
}: React.ComponentProps<typeof Sonner>) => (
  <Sonner
    className="toaster group"
    toastOptions={{
      classNames: {
        toast: cn(['p-5 ', 'flex flex-col gap-4', 'bg-[#1c1c1c]/70 backdrop-blur-[2px] rounded-lg w-[440px]']),
      },
    }}
    position={position}
    offset={offset}
    mobileOffset={mobileOffset}
    style={
      {
        '--width': '440px',
        '--gap': '8px',
      } as React.ComponentProps<typeof Sonner>['style']
    }
    {...props}
  />
)

type ToastProps = {
  id: string | number
  title: React.ReactNode
  titlePrefixIcon?: React.ReactNode
  titleClassName?: string

  description?: React.ReactNode
}

export const toast = (
  { titlePrefixIcon, title, titleClassName, description }: Omit<ToastProps, 'id'>,
  options?: ExternalToast,
) => {
  return sonnerToast.custom(
    (id) => (
      <React.Fragment>
        <HStack className="gap-2 justify-between items-center">
          {titlePrefixIcon}
          <Typography size="h3" className={clsx('flex-1 font-medium', titleClassName)}>
            {title}
          </Typography>
          <button onClick={() => sonnerToast.dismiss(id)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M17.9633 6.03906L6.02837 17.9739"
                stroke="#A5A5A5"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M6.06506 6L17.9999 17.9349"
                stroke="#A5A5A5"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </HStack>
        {description}
      </React.Fragment>
    ),
    options,
  )
}

export const dismissToast = (id?: number | string) => sonnerToast.dismiss(id)
